{
  "familyId": "GET-PROC-VAN",
  "questions": [
    {
      "id": "GET-PROC-VAN-001",
      "familyId": "GET-PROC-VAN",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "skill": "procenten",
      "subSkill": "proc_van_bedrag",
      "questionType": "ratio_table",
      "question": "Vul de tabel aan. Hoeveel is 30% van 150?",
      "context": null,
      "options": ["45", "50", "30", "15"],
      "correctAnswer": 0,
      "data": {
        "headers": ["Percentage", "Bedrag"],
        "rows": [[10, 15], [30, null]],
        "hiddenCells": [{"row": 1, "col": 1}],
        "missingCell": {"row": 1, "col": 1},
        "correctValue": 45,
        "hint": "Als 10% = 15, dan is 30% = 3 × 15"
      },
      "conceptId": "percentage_table_calculation",
      "variantIndex": 1,
      "group": 7,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.75,
      "stimulusAids": [
        {
          "type": "ratio",
          "data": {
            "headers": ["Percentage", "Bedrag"],
            "rows": [
              ["10%", "15"],
              ["30%", "?"]
            ],
            "label": "Verhoudingstabel: 10% van 150 = 15"
          }
        }
      ],
      "supportAids": [
        {
          "type": "ratio",
          "showWhen": "wrong",
          "data": {
            "headers": ["Percentage", "Bedrag"],
            "rows": [
              ["10%", "15"],
              ["30%", "45"]
            ],
            "highlight": [1, 1]
          }
        }
      ],
      "feedback": {
        "explanationText": "Je zoekt 30% van 150. Begin met 10%: dat is 150 ÷ 10 = 15. Nu weet je dat 10% = 15. Omdat 30% drie keer zo veel is als 10%, vermenigvuldig je: 3 × 15 = 45. De verhoudingstabel helpt je dit stap voor stap te zien: als 10% → 15, dan 30% → 3 × 15 = 45.",
        "solutionSteps": [
          "Bereken 10%: 150 ÷ 10 = 15",
          "30% = 3 × 10%",
          "Dus 30% van 150 = 3 × 15 = 45",
          "Check: 45 van de 150 is inderdaad bijna een derde (33%), en 30% ligt daar dichtbij ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 10% van 150 = 15, dus 30% = 3 × 15 = 45.",
          "1": "Je hebt waarschijnlijk 150 ÷ 3 = 50 berekend. Maar delen door 3 geeft 33⅓%, niet 30%. Gebruik de 10%-methode: 10% = 15, dus 30% = 3 × 15 = 45. Onthoud: 30% ≠ een derde.",
          "2": "Je verwart het percentage met het bedrag. 30 is het percentage zelf, niet het resultaat. Je moet 30% van 150 uitrekenen: 10% = 15, dus 30% = 3 × 15 = 45. Onthoud: het percentage is de opdracht, niet het antwoord.",
          "3": "Je hebt alleen 10% berekend (150 ÷ 10 = 15), maar bent vergeten door te rekenen naar 30%. Vermenigvuldig nog met 3: 3 × 15 = 45. Onthoud: 30% = 3 × 10%."
        }
      }
    },
    {
      "id": "GET-PROC-VAN-002",
      "familyId": "GET-PROC-VAN",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "skill": "procenten",
      "subSkill": "proc_van_bedrag",
      "questionType": "ratio_table",
      "question": "Een winkel geeft korting. Vul de tabel aan: hoeveel is 20% korting op €80?",
      "context": null,
      "options": ["€16", "€64", "€20", "€60"],
      "correctAnswer": 0,
      "data": {
        "headers": ["Korting", "Bedrag"],
        "rows": [[10, 8], [20, null]],
        "hiddenCells": [{"row": 1, "col": 1}],
        "missingCell": {"row": 1, "col": 1},
        "correctValue": 16,
        "hint": "Als 10% = €8, dan is 20% = 2 × €8"
      },
      "conceptId": "percentage_discount_table",
      "variantIndex": 2,
      "group": 7,
      "citoDifficulty": 0.43,
      "citoDiscrimination": 0.74,
      "stimulusAids": [
        {
          "type": "ratio",
          "data": {
            "headers": ["Korting", "Bedrag"],
            "rows": [
              ["10%", "€8"],
              ["20%", "?"]
            ],
            "label": "Verhoudingstabel: 10% van €80 = €8"
          }
        }
      ],
      "supportAids": [
        {
          "type": "ratio",
          "showWhen": "wrong",
          "data": {
            "headers": ["Korting", "Bedrag"],
            "rows": [
              ["10%", "€8"],
              ["20%", "€16"]
            ],
            "highlight": [1, 1]
          }
        }
      ],
      "feedback": {
        "explanationText": "Je zoekt 20% korting op €80. Begin met 10%: €80 ÷ 10 = €8. Omdat 20% twee keer zo veel is als 10%, vermenigvuldig je: 2 × €8 = €16. Let op: de vraag is hoeveel de korting is (€16), niet hoeveel je betaalt (€80 − €16 = €64).",
        "solutionSteps": [
          "Bereken 10%: €80 ÷ 10 = €8",
          "20% = 2 × 10%",
          "Dus 20% korting = 2 × €8 = €16",
          "Check: de korting (€16) is minder dan de helft van €80 — dat klopt voor 20% ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 10% van €80 = €8, dus 20% = 2 × €8 = €16 korting.",
          "1": "Je hebt €80 − €16 = €64 berekend. Dat is het bedrag dat je betaalt ná de korting, maar de vraag is hoeveel de korting zelf is. De korting is €16, het nieuwe bedrag is €64. Onthoud: lees goed of ze naar de korting of het nieuwe bedrag vragen.",
          "2": "Je hebt waarschijnlijk €80 ÷ 4 = €20 berekend. Maar delen door 4 geeft 25%, niet 20%. Gebruik de 10%-methode: 10% = €8, dus 20% = 2 × €8 = €16. Onthoud: 20% ≠ een kwart.",
          "3": "Je hebt waarschijnlijk €80 − €20 = €60 berekend, maar €20 is niet de juiste korting. 20% van €80 = 2 × €8 = €16. Onthoud: gebruik de 10%-methode voor nauwkeurig rekenen."
        }
      }
    },
    {
      "id": "GET-PROC-VAN-003",
      "familyId": "GET-PROC-VAN",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "skill": "procenten",
      "subSkill": "proc_van_bedrag",
      "questionType": "multiple_choice",
      "question": "Een fietsenmaker bestelt 360 onderdelen. 15% daarvan is defect. Hoeveel onderdelen zijn defect?",
      "context": null,
      "options": ["54", "36", "45", "60"],
      "correctAnswer": 0,
      "conceptId": "percentage_of_number_1pct",
      "variantIndex": 3,
      "group": 7,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.73,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "15% berekenen met de 1%-methode",
            "content": "Stap 1: Bereken 1% → 360 ÷ 100 = 3,6. Stap 2: 15% = 15 × 1% → 15 × 3,6 = 54. Of via 10% + 5%: 10% = 36, 5% = 18, samen 54.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Je zoekt 15% van 360. Er zijn twee handige methodes. Methode 1 (via 10% + 5%): 10% van 360 = 36. De helft van 10% is 5% = 18. Samen: 36 + 18 = 54. Methode 2 (via 1%): 1% van 360 = 3,6. Dan 15 × 3,6 = 54. Beide methodes geven 54 defecte onderdelen.",
        "solutionSteps": [
          "Bereken 10% van 360: 360 ÷ 10 = 36",
          "Bereken 5% (de helft van 10%): 36 ÷ 2 = 18",
          "15% = 10% + 5% = 36 + 18 = 54",
          "Check: 54 van 360 is iets minder dan een zesde — dat past bij 15% ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 10% van 360 = 36, 5% = 18, dus 15% = 36 + 18 = 54 defecte onderdelen.",
          "1": "Je hebt alleen 10% berekend: 360 ÷ 10 = 36. Maar de vraag is 15%, niet 10%. Je moet er nog 5% bij optellen: 36 + 18 = 54. Onthoud: 15% = 10% + 5%.",
          "2": "Je hebt waarschijnlijk 360 ÷ 8 = 45 berekend, of 10% + 2,5% genomen. Maar 15% = 10% + 5%. 10% = 36, 5% = 18, samen 54. Onthoud: splits het percentage in handige stukken.",
          "3": "Je hebt waarschijnlijk 360 ÷ 6 = 60 berekend. Maar delen door 6 geeft 16⅔%, niet 15%. Gebruik de 10% + 5% methode: 36 + 18 = 54. Onthoud: 15% ≠ een zesde."
        }
      }
    },
    {
      "id": "GET-PROC-VAN-004",
      "familyId": "GET-PROC-VAN",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "skill": "procenten",
      "subSkill": "proc_van_bedrag",
      "questionType": "fill_in",
      "question": "Een school heeft 240 leerlingen. 35% van de leerlingen doet mee aan de sportdag. Hoeveel leerlingen doen mee?",
      "context": null,
      "correctAnswer": "84",
      "data": {
        "acceptedAnswers": ["84", "84 leerlingen"],
        "caseSensitive": false,
        "placeholder": "... leerlingen"
      },
      "conceptId": "percentage_of_number_split",
      "variantIndex": 4,
      "group": 7,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.71,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "35% berekenen: splits in handige stukken",
            "content": "35% = 30% + 5%. Bereken 10% eerst: 240 ÷ 10 = 24. Dan: 30% = 3 × 24 = 72. En 5% = 24 ÷ 2 = 12. Samen: 72 + 12 = 84.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Je zoekt 35% van 240 leerlingen. Splits 35% in handige stukken: 30% + 5%. Bereken eerst 10%: 240 ÷ 10 = 24. Dan is 30% = 3 × 24 = 72. En 5% is de helft van 10% = 24 ÷ 2 = 12. Tel op: 72 + 12 = 84 leerlingen doen mee aan de sportdag.",
        "solutionSteps": [
          "Bereken 10% van 240: 240 ÷ 10 = 24",
          "Bereken 30%: 3 × 24 = 72",
          "Bereken 5% (helft van 10%): 24 ÷ 2 = 12",
          "35% = 30% + 5% = 72 + 12 = 84 leerlingen",
          "Check: 84 van 240 is iets meer dan een derde (80) — dat past bij 35% ✓"
        ],
        "distractorExplanations": {}
      }
    },
    {
      "id": "GET-PROC-VAN-005",
      "familyId": "GET-PROC-VAN",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "skill": "procenten",
      "subSkill": "proc_van_bedrag",
      "questionType": "multiple_choice",
      "question": "Een boer oogst 450 kilo appels. Hij verkoopt 12% aan een restaurant. Hoeveel kilo verkoopt hij aan het restaurant?",
      "context": null,
      "options": ["54 kg", "45 kg", "540 kg", "36 kg"],
      "correctAnswer": 0,
      "conceptId": "percentage_of_number_1pct_method",
      "variantIndex": 5,
      "group": 7,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.70,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "12% berekenen met de 1%-methode",
            "content": "Stap 1: 1% van 450 = 450 ÷ 100 = 4,5. Stap 2: 12% = 12 × 4,5 = 54. Of: 10% = 45, 2% = 9, samen 54.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Je zoekt 12% van 450 kilo. Methode 1 (via 10% + 2%): 10% van 450 = 45. Dan 2% = 2 × 4,5 = 9. Samen: 45 + 9 = 54 kilo. Methode 2 (via 1%): 1% van 450 = 4,5. Dan 12 × 4,5 = 54 kilo. De boer verkoopt 54 kilo appels aan het restaurant.",
        "solutionSteps": [
          "Bereken 10% van 450: 450 ÷ 10 = 45",
          "Bereken 1% van 450: 450 ÷ 100 = 4,5",
          "Bereken 2%: 2 × 4,5 = 9",
          "12% = 10% + 2% = 45 + 9 = 54 kilo",
          "Check: 54 van 450 is ongeveer een negende — dat past bij 12% ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 10% van 450 = 45, 2% = 9, dus 12% = 45 + 9 = 54 kilo appels.",
          "1": "Je hebt alleen 10% berekend: 450 ÷ 10 = 45. Maar de vraag is 12%, niet 10%. Je moet er nog 2% bij optellen: 45 + 9 = 54. Onthoud: 12% = 10% + 2%.",
          "2": "Je hebt waarschijnlijk 12 × 45 = 540 berekend. Maar 45 is al 10% — je hoeft niet nog eens met 12 te vermenigvuldigen. 12% = 10% + 2% = 45 + 9 = 54. Onthoud: splits het percentage, vermenigvuldig niet dubbel.",
          "3": "Je hebt waarschijnlijk 450 ÷ 12 = 37,5 berekend en afgerond naar 36. Maar delen door 12 geeft niet 12%. Gebruik de 10%-methode: 10% = 45, 2% = 9, samen 54. Onthoud: 12% ≠ delen door 12."
        }
      }
    }
  ]
}